// extracted by mini-css-extract-plugin
export default {"wrapper":"BannerOne_wrapper__M3Qy6","wrap":"BannerOne_wrap__aRFF2"};